// extracted by mini-css-extract-plugin
export default {"content":"rUxG6","info-container":"Jxdeg","avatar-wrapper":"iVg3z","avatar":"tmlfm","owner-name":"JK6VR","date":"Arjxh","message":"Rc02I","media-container":"y29mV"};